<template>
    <div class="result-box">
      <a-spin class="loading_ customLoading" size="large" v-show="!isMobile"  :spinning="spinningShow" :tip="'结果查询中'"></a-spin>
      <div v-show="isMobile" class="mobile">
        <a-spin class="loading_ customLoading" size="large" :spinning="spinningShow" :tip="'结果查询中'"></a-spin>
      </div>
      <a href="#" ref="success"></a>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        isMobile: false,
        policyId: '',
        isSuccess: false, // 投保成功
        isFail: false, // 投保失败
        timer: null,
        errorTip: '',
        spinningShow: true,
		productCode: '' // 产品code
      };
    },
    computed: {
      checkRiskUpload() {
        let rickObj = JSON.parse(sessionStorage.getItem('checkRiskUpload'));
        return rickObj;
      },
    },
    created() {
      const { policyId, productCode } = this.$route.query;
      this.policyId = policyId;
			this.productCode = productCode;
      this.savePageSuc();
      this.isMobile = this.isMobileFunc();
    },
    mounted() {
        this.startLoop();
    },
    methods: {
    //判断设备是PC端还是移动端: false PC端 | true 移动端
    isMobileFunc (){
      return !!navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|WebOS|Windows Phone|Phone)/i);
    },
    savePageSuc() {
      this.$api.savePageSuc({
        closeType: "pending-page",
        policyId: this.policyId,
        msgId: sessionStorage.getItem('clairvoyance_message_id'),
      }).then((res) => {
        console.log(res)
      })
    },
	startLoop() {
        //轮询支付结果
        let i = 20;
        let policyId = this.policyId;
        this.timer = setInterval(() => {
        i--;
		if (i < 1) {
            // 最多请求20次，无结果去指引页
            this.$router.push({
                path: "/result-waiting",
                query: {
                    policyId: policyId,
                    productCode: this.productCode
                },
            });
            clearInterval(this.timer);
            return;
		}
		this.$api
			.queryPolicy({
                policyId
            }) //获取订单信息 是否支付成功
            .then(res => res.data)
            .then(data => {
			const { returnCode, returnMsg, content} = data;
            if (returnCode == '00') {
                //支付成功
                clearInterval(this.timer); //结束轮询
                this.spinningShow = false;
                if(content.isSplit === 'Y') { // 拆单逻辑
                    if (content.hipSalOrder.status === '1' || content.hipSalOrder.status === '11') {
                        this.$router.push({
                            path: '/result-success',
                            query: {
                                isYan: content.isYan,
                                policyNo: content.policyNo,
                                policyId: policyId,
                                receipt: this.$route.query.receipt || "",
                                visit: this.$route.query.visit || "",
                            }
                        })
                    } else {
                        this.$router.push({
                            path: '/result-fail',
                            query: {
                                policyId: policyId
                            }
                        })  
                    }
                    return
                  }

                  // 正常逻辑
                  this.$router.push({
                    path: '/result-success',
                    query: {
                        isYan: content.isYan,
                        policyNo: content.policyNo,
                        policyId: policyId,
                        receipt: this.$route.query.receipt || "",
                        visit: this.$route.query.visit || "",
                    }
                  })
              } 
            if (returnCode == '1042') {
              this.errorTip = returnMsg;
              this.spinningShow = false;
              clearInterval(this.timer); //结束轮询
              this.$router.push({
                path: '/result-fail',
                query: {
                  errorTip: this.errorTip,
                  policyId: policyId
                }
              })        
                      }
                  })
                  .catch(err => {
                      console.log(err)
                      this.isFail = true;
            this.spinningShow = false;
                      clearInterval(this.timer);
            this.$router.push({
              path: '/result-fail',
              query: {
                policyId: policyId,
                errorTip: this.errorTip,
              }
            })
                  });
              }, 3000);
          },
      },
      
    };
  </script>
  <style lang="scss" scoped>
      .result-box {
          background: #fff;
          min-height: 100vh;
          min-width: 100vw;
          z-index: 9999999;
          padding-top: 20px;
          position: fixed;
          top: 0;
          left: 0;
      ::v-deep .mobile {
         .customLoading {
          .ant-spin-dot-spin {
            .ant-spin-dot-item {
                background-color: #1B7CF8;
              }
          }
        }
        .ant-spin {
          color: #1B7CF8;
        }
      }
      }
      
    .error-box,
    .success_  {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      align-items: center;
      img {
          width: 200px;
      }
    }
    .error-box,
    .success_ {
      .text_info {
        margin: 10px 0;
      }
  
      .text_ {
        font-size: 11px;
        font-family: Microsoft YaHei UI;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
      }
  
      .text_1 {
        font-size: 18px;
        font-weight: bold;
        color: rgba(254, 152, 69, 1);
        text-align: center;
      }
  
      .btn_list {
        display: flex;
        justify-content: center;
  
        .btn_ {
          margin: 19px;
          border: 1px solid rgba(254, 143, 45, 1);
          width: 150px;
          height: 35px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          color: rgba(254, 143, 45, 1);
  
          .btn_a {
            color: inherit;
            flex: 1;
            text-align: center;
          }
        }
  
        .btn_:hover {
          color: #fff;
          background: rgba(254, 143, 45, 1);
        }
      }
    }
  
    .success-test {
      font-size: 16px;
      text-indent: 2em;
    }
  </style>
  